import { LoaderOptions } from '@googlemaps/js-api-loader';

/* `LoaderOptions` type with the `apiKey` property made optional */
export type GoogleMapsLoaderOptions = Omit<LoaderOptions, 'apiKey'> &
  Partial<LoaderOptions>;

export const cignaGoogleMapsConfig: GoogleMapsLoaderOptions = {
  client: 'gme-cigna',
  libraries: ['places'],
};

export const esiGoogleMapsConfig: GoogleMapsLoaderOptions = {
  apiKey: 'AIzaSyAsg0bIKADP3RXXsc-q36hj_Qrq51wuttM',
  libraries: ['places'],
};

export const evernorthGoogleMapsConfig: GoogleMapsLoaderOptions = {
  apiKey: 'AIzaSyC8zawglxIpG4XP9ekdK2RFH1QhNBMz0cg',
  libraries: ['places'],
};

export const cignaForEmployersGoogleMapsConfig: GoogleMapsLoaderOptions = {
  apiKey: 'AIzaSyBbKeS-IjgyIvOf2RWrPO5Qtry-pirP8l0',
  libraries: ['places'],
};
